import axios from 'axios/lib/axios';
import 'url-search-params-polyfill';

const base = '/auth/';

const endpoints = {
  refresh: function(token) {
    return axios.post(
      `${base}refresh`,
      {},
      {
        headers: {
          Authorization: `Bearer ` + token,
        },
      },
    );
  },
};

export default endpoints;
